export default function getIdentity() {
  return <T>(t: T): T => t
}
